export function SkeletonTable({ columns = 4, rows = 4 }) {
    const rowHeaders = [];
    for (let i = 0; i < columns; i++) {
        rowHeaders.push(<div key={i} className="bg-gray-150 p-5 animate-pulse"></div>);
    }

    const rowColumns = [];
    for (let i = 0; i < columns; i++) {
        rowColumns.push(
            <div key={i} className={`animate-pulse bg-gray-150 p-3 mb-1 gap-3 rounded-lg`}>
                <div className="bg-white rounded-lg p-1 w-3/4"></div>
            </div>
        );
    }

    const rowPlaceholders = [];
    for (let i = 0; i < rows; i++) {
        rowPlaceholders.push(<div key={i}>{rowColumns}</div>);
    }

    return (
        <div className={`w-full py-3 grid grid-cols-${columns} gap-3`}>
            {rowHeaders}
            {rowPlaceholders}
        </div>
    );
}
